/*=============================================
=            Data Card Styling          =
=============================================*/
@import './pk-data-card.variables';

:host {
  @apply block h-[--data-card--height] w-[--data-card--width];
}

.pk-data-card__outline {
  @apply touch-vertical flex h-full w-full flex-col overflow-y-auto bg-[color:--data-card--background-color];
  @apply rounded-[--data-card--border-radius];
  font-family: var(--pk-font-base-semibold);

  &.has-shadow {
    box-shadow: var(--data-card--box-shadow);
  }

  &.has-stroke {
    @apply border-[length:--data-card--border-width] border-solid border-[color:--data-card--border-color];
  }
}

.cta-container {
  ::slotted(pk-button) {
    @apply [--button--font-size:--pk-font-size-s] #{!important};
  }
}
